<template>
  <div v-if="totalPages() > 0" class="paginationContainer text-center">
    <div class="btn-group ">
      <button
        v-if="showPreviousLink()"
        v-on:click="updatePage(currentPage - 1)"
        class="btn btn-sm s-btn-sm page-btn"
      >
        <i class="fa fa-chevron-left"></i>
      </button>
      <span class="btn btn-sm s-btn-sm  page-num">
        {{ currentPage + 1 }}
      </span>
      <button
        v-if="showNextLink()"
        v-on:click="updatePage(currentPage + 1)"
        class="btn btn-sm s-btn-sm page-btn"
      >
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["users", "currentPage", "pageSize"],
  methods: {
    updatePage(pageNumber) {
      this.$emit("page:update", pageNumber);
    },
    totalPages() {
      if (this.users[0] != undefined) {
        return Math.ceil(this.users[0].length / this.pageSize);
      }
    },
    showPreviousLink() {
      return this.currentPage == 0 ? false : true;
    },
    showNextLink() {
      return this.currentPage == this.totalPages() - 1 ? false : true;
    }
  }
};
</script>

<style scoped>
.paginationContainer {
  /*margin-left: 10px;*/
  width: 110px;
  margin-left: auto;
  margin-right: auto;
}
.page-btn {
  background: white;
}
.page-num {
  cursor: inherit;
}
</style>
